import React from 'react';
import { NavLink } from 'react-router-dom';

const PayslipsCrumb = () => <NavLink to="/human-resources/payslips">Payslips</NavLink>;

export default PayslipsCrumb;
